module.exports = __webpack_public_path__ + "static/img/zijie.8b4a6b1f.svg";